import React, { useEffect, useState } from "react";
import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { recibirChequeFisicoCc } from "./ApiServices";
import { formatMoneda } from "../pago_proveedores/utils";
import { idInstrumentoFisico } from "./chequesFisicos.constants";

export default function ModalRecibirCC({
  open,
  onClose,
  cheques = [],
  onOk,
}) {
  const [obs, setObs] = useState("");
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState("");

  const lista = Array.isArray(cheques)
    ? cheques.filter((c) => idInstrumentoFisico(c))
    : [];
  const lote = lista.length > 1;

  useEffect(() => {
    if (!open) return;
    setObs("");
    setError("");
  }, [open]);

  const guardar = async () => {
    if (!lista.length) return;
    setGuardando(true);
    setError("");
    try {
      const body = { obs: obs.trim() || undefined };
      for (const cheque of lista) {
        await recibirChequeFisicoCc(idInstrumentoFisico(cheque), body);
      }
      onOk?.();
      onClose?.();
    } catch (err) {
      setError(err.message || "Error al recibir en Casa Central");
    } finally {
      setGuardando(false);
    }
  };

  const total = lista.reduce((acc, c) => acc + (Number(c.importe) || 0), 0);

  return (
    <Dialog
      open={open}
      onClose={guardando ? undefined : onClose}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle>
        {lote
          ? `Recibir en Casa Central (${lista.length} cheques)`
          : `Recibir — N° ${lista[0]?.nro_cheque || idInstrumentoFisico(lista[0]) || ""}`}
      </DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2}>
          {error ? <Alert severity="error">{error}</Alert> : null}
          <Typography variant="body2" color="text.secondary">
            La custodia pasa a Casa Central (sucursal 8). Total:{" "}
            <strong>{formatMoneda(total)}</strong>.
          </Typography>
          <TextField
            label="Observaciones (opcional)"
            size="small"
            fullWidth
            multiline
            minRows={2}
            value={obs}
            onChange={(e) => setObs(e.target.value)}
            disabled={guardando}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={guardando}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          onClick={guardar}
          disabled={guardando || !lista.length}
          startIcon={
            guardando ? <CircularProgress size={16} color="inherit" /> : null
          }
        >
          Marcar recibido
        </Button>
      </DialogActions>
    </Dialog>
  );
}
